import { group } from '@angular/animations';
import { AbstractControl, ValidationErrors } from '@angular/forms';


export function confirmPassword(group: AbstractControl): ValidationErrors | null {
  if (!group) return { notSame: true }
  const pass = group.get('password')?.value;
  const confirmPass = group.get('confirmPassword')?.value

  if (!pass || !confirmPass) return null
  return pass === confirmPass ? null : { notSamePassword: true }
}
